export default {
  icon_text: 'Zamknięte',
  buttons: {
    ok: 'Ok',
  },
};
